import { publicRequest } from '../../../util/SuperagentUtils';
import { supplierProfileRequests } from '../../../requests/api-endpoints';

/**
 * Fetches a public supplier profile. Uses the public request agent (no 401
 * logout redirect) because this endpoint does not require authentication.
 */
export const getSupplierProfile = (shortId: string, slug: string): Promise<any> => {
  return publicRequest.get(supplierProfileRequests.getPublicSupplierProfile(encodeURIComponent(shortId), encodeURIComponent(slug)));
};
